import { render, staticRenderFns } from "./IcoCalendar.vue?vue&type=template&id=149b6115&"
import script from "./IcoCalendar.vue?vue&type=script&lang=js&"
export * from "./IcoCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports